import { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { ContratCreateDialog, TYPES } from "@/components/ContratCreateDialog";
import { ContratDetail } from "@/components/ContratDetail";

const STATUT = { brouillon: ["Brouillon", "bg-slate-200 text-slate-700"], a_signer: ["À signer", "bg-amber-100 text-amber-800"],
  en_signature: ["En signature", "bg-blue-100 text-blue-800"], signe: ["Signé", "bg-emerald-100 text-emerald-800"] };

export default function Contrats() {
  const { user } = useAuth();
  const canEdit = ["admin", "gestionnaire_ge"].includes(user?.role);
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState(null);
  const [creating, setCreating] = useState(false);
  const load = useCallback(() => api.get("/contrats").then((r) => setRows(r.data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail))), []);
  useEffect(() => { load(); }, [load]);
  const open = async (id) => {
    try { const { data } = await api.get(`/contrats/${id}`); setSel(data); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <div className="space-y-6" data-testid="contrats-page">
      <PageHeader title="Contrats de travail" subtitle="CDI, CDD, temps partiel et temps partagé GE : rédaction par ZOE, contrôle des mentions obligatoires, PDF en GED et signature."
        actions={canEdit && <Button onClick={() => setCreating(true)} data-testid="contrat-nouveau" className="bg-[#17352e] text-white hover:bg-[#284b40]"><Plus className="h-4 w-4 mr-1" />Nouveau contrat</Button>} />
      <div className="grid lg:grid-cols-[340px_1fr] gap-6">
        <div className="rounded-xl border border-slate-200 bg-white divide-y self-start" data-testid="contrats-liste">
          {rows.length === 0 && <p className="p-4 text-sm text-slate-500">Aucun contrat.</p>}
          {rows.map((c) => (
            <button key={c.id} type="button" onClick={() => open(c.id)} data-testid={`contrat-row-${c.id}`}
              className={`w-full text-left p-3 hover:bg-slate-50 transition-colors ${sel?.id === c.id ? "bg-[#FDF9F1]" : ""}`}>
              <div className="flex justify-between gap-2"><span className="font-medium text-sm">{c.numero}</span>
                <Badge className={STATUT[c.statut]?.[1]} data-testid={`contrat-statut-${c.id}`}>{STATUT[c.statut]?.[0]}</Badge></div>
              <div className="text-xs text-slate-500">{c.salarie_nom} · {TYPES.find(([v]) => v === c.type)?.[1]}{c.bloquants ? ` · ${c.bloquants} à compléter` : ""}</div>
            </button>
          ))}
        </div>
        <div>{sel ? <ContratDetail key={sel.id} contrat={sel} role={user?.role} onChange={(d) => { setSel(d); load(); }} />
          : <p className="text-sm text-slate-500">Sélectionnez un contrat.</p>}</div>
      </div>
      <ContratCreateDialog open={creating} onClose={() => setCreating(false)} onCreated={(d) => { load(); setSel(d); }} />
    </div>
  );
}
